import uniqBy from 'lodash/uniqBy';
import PrizeIcon from 'containers/Auctions/Auction/PrizeIcon';
import Cycler from 'containers/Auctions/components/Cycler';
import ProfileIcon from 'components/ProfileIcon';
import TextCycler from 'components/TextCycler';

const LeaderboardPrizeCycler = ({ categories }) => {
  return (
    <div className="cat-logo">
      <Cycler items={categories} />
    </div>
  );
};

const DrawingName = ({ drawing }) => {
  const numOfPrizes = drawing.totalPlaces;
  const places =
    (drawing.winningPlaces && drawing.winningPlaces.winningPlaces) || [];
  const prizeNamesList = places.map(place => place.prize.name);

  return (
    <div className="name">
      <span>
        {numOfPrizes === 1 ? numOfPrizes + ' prize' : numOfPrizes + ' prizes'}
      </span>
      <TextCycler items={prizeNamesList} />
    </div>
  );
};

const LeaderboardHeader = ({ drawing, ticketsData }) => {
  let places =
    (drawing.winningPlaces && drawing.winningPlaces.winningPlaces) || [];
  let prizeCategoriesList = [];

  for (let i = 0; i < places.length; i++) {
    let prizeCategory = places[i].prize;
    prizeCategoriesList.push(prizeCategory);
  }

  const prizeIcons = uniqBy(prizeCategoriesList, 'category').map(item => (
    <PrizeIcon key={item.category} category={item.category} />
  ));

  return (
    <div className="header">
      <LeaderboardPrizeCycler categories={prizeIcons} />
      <DrawingName drawing={drawing} />
      <div className="players-num">
        <span className="notranslate">{ticketsData.players} </span>
        <span>{ticketsData.players === 1 ? 'PLAYER' : 'PLAYERS'}</span>
      </div>
    </div>
  );
};

const LeaderboardPlayersList = ({ tops, me, myPos }) => {
  const myId = me.userId;

  return (
    <div className="players-list">
      {tops.map((item, idx) => {
        return (
          <div
            key={idx}
            className={
              'player' +
              (item.user.userId === myId ? ' me' : '') +
              (item.pos === 0 ? ' first-place' : '')
            }
          >
            <ProfileIcon
              avatarData={item.user.avatarData}
              size={40}
              withBorder
            />

            <div className="inner">
              <div
                className="displayName notranslate"
                title={item.user.displayName}
              >
                {item.user.displayName}
              </div>
              <div className="ticketsCount">
                <span className="notranslate">{item.ticketsCount} </span>
                <span>{item.ticketsCount === 1 ? 'entry' : 'entries'}</span>
              </div>
            </div>
            <div className="pos notranslate">{item.pos + 1}</div>
          </div>
        );
      })}
    </div>
  );
};

const LeaderboardFooter = ({ me, myTicketsCount, more, myPos }) => {
  return (
    <div className="player me footer">
      <ProfileIcon avatarData={me.avatarData} size={40} border="border" />
      <div className="outer">
        <div className="inner">
          <div className="displayName notranslate" title={me.displayName}>
            {me.displayName}
          </div>
          {!more && (
            <div className="ticketsCount">
              <span className="notranslate">{myTicketsCount} </span>
              <span>{myTicketsCount === 1 ? 'entry' : 'entries'}</span>
            </div>
          )}
        </div>
        {more && (
          <div className="hint">
            <span>Enter </span>
            <span className="more-tickets">{more} entries</span>
            <span> to get on leaderboard</span>
          </div>
        )}
      </div>
      <div className={'notranslate pos' + (myPos === 1 ? ' first' : '')}>
        {myPos}
      </div>
    </div>
  );
};

const DrawingLeaderboard = ({
  board,
  userData,
  ticketsData,
  myTickets,
  drawing,
  drumClosed
}) => {
  const me = userData.user;
  const myId = me.userId;
  const MAX_BOARD_LENGTH = 20;

  let myPos = '-';
  let myIdx = -1;
  let myTicketsCount = myTickets;
  let tops = [...board];
  let pos = 0;

  const boardLen = tops.length;

  tops.sort(
    (lhs, rhs) =>
      rhs.ticketsCount +
      (rhs.user.userId === myId ? 0.1 : 0) -
      (lhs.ticketsCount + (lhs.user.userId === myId ? 0.1 : 0))
  );

  for (let i = 0; i < boardLen; ++i) {
    if (i && tops[i].ticketsCount !== tops[i - 1].ticketsCount) {
      ++pos;
    }
    tops[i].pos = pos;

    if (tops[i].user.userId === myId) {
      myPos = pos + 1;
      myIdx = i;
    }
  }

  let more = false;
  if (!drumClosed && drawing.allTicketsAllowed) {
    if (boardLen === MAX_BOARD_LENGTH) {
      if (myIdx === -1) {
        more =
          '' + (tops[MAX_BOARD_LENGTH - 1].ticketsCount - myTicketsCount + 1);
      }
    } else if (boardLen > 0) {
      if (myIdx === -1) {
        more = 'any amount of';
      }
    } else {
      more = 'any amount of';
    }
  }

  return (
    <div className="board">
      <LeaderboardHeader drawing={drawing} ticketsData={ticketsData} />
      <LeaderboardPlayersList
        tops={tops}
        me={me}
        myTicketsCount={myTicketsCount}
        more={more}
        myPos={myPos}
      />
      <LeaderboardFooter
        me={me}
        myTicketsCount={myTicketsCount}
        more={more}
        myPos={myPos}
      />
    </div>
  );
};

export default DrawingLeaderboard;
